import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import {
  fetchAllPrompt,
  fetchApplicationsData,
  fetchAllPrompt_new,
  fetchMyPrompt_new,
  fetchAllPromptDetails,
  fetchPlaygroundHistory
} from '../service/apiServices';
import { useAzureData } from './AzureContext';
type PromptLibraryContextType = {
  applicationList: App[] | null;
  // prompts: PromptInfo[];
  error: any;
  isLoading: boolean;
  allPromptData: any;
  myPromptData: any;
  getPromptlibraryData: () => {};
  codeView: boolean;
  setCodeView: (a: boolean) => {};
  getPromptDetails: (a: string) => {};
  codeViewPromptId: boolean;
  setCodeViewPromptId: (a: string) => {};
  promptDetails: any;
};
type PromptLibraryContextProviderProps = {
  children: ReactNode;
};
type App = {
  application_id: string;
  application_name: string;
};
type PromptInfo = {
  id: string;
  version: any;
  prompt_id: string;
  app_name: string;
  llm_tested_with: string;
  description: string;
  category: string;
  creation_date: string;
  last_modified_date: string;
  usage_examples: string;
  author: string;
};
export const PromptLibraryContext = createContext<PromptLibraryContextType | null>(null);
export const PromptLibraryContextProvider = ({ children }: PromptLibraryContextProviderProps) => {
  const [applicationList, setApplicationList] = useState<App[] | null>(null); //applications
  // const [prompts, setPrompts] = useState<PromptInfo[] | []>([]);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [allPromptData, setAllPromptData] = useState([]);
  const [myPromptData, setMyPromptData] = useState([]);
  const { apiToken } = useAzureData();
  const getPromptlibraryData = async () => {
    try {
      const applicationlist = await fetchApplicationsData(apiToken);
      setApplicationList(applicationlist);
      // const listofprompts = await fetchAllPrompt(apiToken);
      // setPrompts(listofprompts);
      const allPrompts = await fetchAllPrompt_new(apiToken);
      setAllPromptData(allPrompts);
      const myPrompt = await fetchMyPrompt_new(apiToken);
      setMyPromptData(myPrompt);
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const promptLibaryData = useMemo(
    () => ({
      applicationList,
      // prompts,
      allPromptData,
      myPromptData,
      getPromptlibraryData,
      error,
      isLoading
    }),
    [apiToken, isLoading, allPromptData, myPromptData]
  );

  const [promptDetails, setPromptDetails] = useState({ data: {}, error: '', loading: false });

  const getPromptDetails = async (id: string) => {
    setPromptDetails((prev) => ({ ...prev, loading: true }));
    try {
      const promptDetail = await fetchAllPromptDetails(id, apiToken);
      setPromptDetails((prev) => ({ ...prev, data: promptDetail }));
    } catch (error: any) {
      setPromptDetails((prev) => ({ ...prev, error: error }));
    } finally {
      setPromptDetails((prev) => ({ ...prev, loading: false }));
    }
  };
  const promptData = useMemo(
    () => ({
      getPromptDetails,
      promptDetails
    }),
    [promptDetails, getPromptDetails]
  );

  const [codeView, setCodeView] = useState(false);
  const [codeViewPromptId, setCodeViewPromptId] = useState('');

  const codeViewMemo = useMemo(
    () => ({
      codeView,
      setCodeView,
      codeViewPromptId,
      setCodeViewPromptId
    }),
    [codeView]
  );

  return (
    <PromptLibraryContext.Provider value={{ ...promptLibaryData, ...promptData, ...codeViewMemo }}>
      {children}
    </PromptLibraryContext.Provider>
  );
};
export const usePromptLibraryContext = () => {
  const context = useContext(PromptLibraryContext);
  if (context === null) {
    throw new Error('usePromptLibraryContext must be used within a DataProvider');
  }
  return context;
};
